import { Component, Input, ChangeDetectorRef, OnChanges, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Observable } from 'rxjs'
import { skip } from 'rxjs/operators'
//import { ApiService } from '../../article.service'
import { ArticleService } from '../../../core/services/article.service'
import { SharedDataService } from 'src/app/core/services/shared-data.service'

export interface IArticle{
  url: string
  title: string,
  category: string,
  excerpt: string,
  publishDate: Date,
  authorId: string,
  type: string,
  body: any,
  thumbnail: any,
  headerImage: any,
  headerVideo?: any,
  pdf?: any
}

@Component({
    selector: 'app-articles',
    templateUrl: './articles.component.html',
    styleUrls: ['./articles.component.scss'],
    standalone: false
})

export class ArticlesComponent implements OnInit, OnChanges {

  articles: any[]
  @Input() breakpoints: any = [{}]
  articlesList: any = []
  articlePage = 0
  showArticle = false
  articleContent: IArticle

  constructor(
    private cdr: ChangeDetectorRef,
    //private api: ApiService,
    private articleService: ArticleService,
    public sharedDataService: SharedDataService,
    public router: Router) {}

  ngOnInit(): void {
    this.articleService.articles.subscribe(res => {
      if (res[0].url !== 'empty'){
        this.articles = res
        this.cdr.detectChanges()
      }

    }, (error: any) => {
      console.error(error)
    })
  }

  ngOnChanges(): void {
    this.cdr.detectChanges()
  }

  onPageChange(e: number) {
    this.articlePage = e
  }
  toArticle(url: string){
    this.router.navigate(['/article', url])
  }

}
